import type * as React from "react";
import { Text } from "react-aria-components";
import {
  supportTextClass,
  textContent,
  textWrapper,
} from "./SupportingText.css.ts";

type SupportingTextProps = {
  isDisabled: boolean;
  children: React.ReactNode;
} & (
  | { size: "m"; supportingText?: React.ReactNode }
  | { size: "s"; supportingText?: React.ReactNode }
  | { size: "xs"; supportingText?: never }
);

export const SupportingText: React.FC<SupportingTextProps> = ({
  isDisabled,
  supportingText,
  children,
  size,
}) => (
  <div
    className={textWrapper({
      hasSupportingText: supportingText != null,
      isDisabled,
    })}
  >
    <div className={textContent({ size })}>{children}</div>
    {supportingText != null && (
      <Text slot="description" className={supportTextClass({ size })}>
        {supportingText}
      </Text>
    )}
  </div>
);
